import { selectTheme } from './select';

// multiselect shares root, overlay and option with select, so it takes select's
// values rather than a copy that could drift. Without it Aura's defaults
// applied: a darker hover border and the primary-tinted selected option.
export const multiselectTheme = {
  colorScheme: selectTheme.colorScheme
};
